module.exports = __webpack_public_path__ + "fonts/DINPro-Bold.399d7b91.woff2";